export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Any-Wind Lesson Finder',
    body: 'Find a lesson that fits today’s group and wind in a minute or two. One chart crosses level, age and goal for all 131 Lesson Cards, flags the shore cards for wrong-air days and points you to the right page.',
    cover: 'https://cdn.magicpatterns.com/uploads/t1X7pVWK2mNGYQH4rsX6xo/DPS48_-_Bono_1_-_The_Any-Wind_Lesson_Finder.png',
    accent: 'bg-peach',
  },
  {
    number: '02',
    title: 'The Coach Boat Card Kit',
    body: 'Take the day’s lessons out on the water in your pocket. Print any Lesson Card at pocket size, slip it into a waterproof sleeve and fill in a one-card plan for the day.',
    cover: 'https://cdn.magicpatterns.com/uploads/hrimrNr1LvFy9DqsicY4sz/DPS48_-_Bono_2_-_The_Coach_Boat_Card_Kit.png',
    accent: 'bg-teal',
  },
  {
    number: '03',
    title: 'The Venue & Boat Adapter',
    body: 'Adapt the lessons to your water and your fleet. Quick rules for rivers, lakes, tidal water and tight harbors, and for singlehanders, doublehanders and small keelboats.',
    cover: 'https://cdn.magicpatterns.com/uploads/1d2fpy15xg9YHBAPHiL89U/DPS48_-_Bono_3_-_The_Venue__Boat_Adapter.png',
    accent: 'bg-sage',
  },
  {
    number: '04',
    title: 'The Syllabus Match Sheet',
    body: 'Line the pack up with the syllabus you already teach. List your program’s skills once and match each one to the Lesson Cards that cover it.',
    cover: 'https://cdn.magicpatterns.com/uploads/fSw9LUYZnnGohKzNotXCEg/DPS48_-_Bono_4_-_The_Syllabus_Match_Sheet.png',
    accent: 'bg-rose',
  },
  {
    number: '05',
    title: 'Build Your Own Any-Wind Lesson',
    body: 'Turn your favorite drills into Any-Wind Lesson Cards: a printable blank Lesson Card plus a step-by-step guide to write the Light Air and Wrong Air versions of the drills you already teach.',
    cover: 'https://cdn.magicpatterns.com/uploads/nfpfTtVzssRcVroekbFk7z/DPS48_-_Bono_5_-_Build_Your_Own_Any-Wind_Lesson.png',
    accent: 'bg-lav',
  },
]
